import { createFileRoute } from "@tanstack/react-router";

import { CompanyInit } from "@/components/layouts/company-init";
import { MainLayout } from "@/components/layouts/main-layout";
import Navbar from "@/components/shared/app-navigation/navbar";
import { Separator } from "@/components/ui/separator";
import Transactions from "@/features/transactions/accounting/export";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/transaktionen/export",
)({
  component: TransactionsPage,
  staticData: {
    breadcrumb: ["bank.link"],
  },
});

function TransactionsPage() {
  return <Transactions />;
}
